module.exports = "/_next/static/images/390d67ca22ac44a7b54def7932242775-nubanker-tpm@0.75x.jpg";